import { AlreadyTranslatedText } from '@execonline-inc/translations';
import { Decoder, string } from 'jsonous';

export const alreadyTranslatedTextDecoder: Decoder<AlreadyTranslatedText> = string.map((s) => ({
  kind: 'already-translated-text' as const,
  text: s,
}));
